export function HavingTroubleLink({
  supportEmail,
}: {
  supportEmail: string | null | undefined;
}) {
  const email = supportEmail?.trim();
  if (!email) return null;

  const mailto = `mailto:${email}?subject=${encodeURIComponent("Can't Access the Meeting")}&body=${encodeURIComponent(
    "Hey team,\n\nI'm having trouble logging in.\n\nHelp!\n",
  )}`;

  return (
    <div className="text-center">
      <a
        href={mailto}
        className="text-sm text-gray-400 underline underline-offset-2 hover:text-white inline-block"
      >
        Having trouble?
      </a>
    </div>
  );
}
